import styled from "styled-components";
import {variant} from "styled-system";
import css from "@styled-system/css";
import * as vars from "../shared/variables";
import {BadgeType} from "../interfaces";

interface BadgeProps {
  /**
   * This defines the background and text colors
   */
  type: BadgeType;
  /**
   * Text content for the badge
   */
  text: string | any;
  /**
   * Defines the size of the badge
   */
  size?: "xSmall" | "small" | "medium" | "large";
  /**
   * Has background
   */
  background?: boolean;
}

const BadgeComponent = styled.span<BadgeProps>(
  css({
    padding: "4px 12px",
    borderRadius: "40px",
    display: "inline-block",
  }),
  ({type}) =>
    variant({
      prop: "type",
      variants: {
        info: {
          backgroundColor: vars.backgroundBlue,
          color: vars.textBlue,
        },
        success: {
          backgroundColor: vars.backgroundGreen,
          color: vars.textGreen,
        },
        warning: {
          backgroundColor: vars.backgroundOrange,
          color: vars.textOrange,
        },
        danger: {
          backgroundColor: vars.backgroundRed,
          color: vars.textRed,
        },
        neutral: {
          backgroundColor: vars.backgroundColor,
          color: vars.secondaryFontColor,
        },
      },
    }),
  ({size}) =>
    variant({
      prop: "size",
      variants: {
        xSmall: {
          fontSize: vars.fontSizeXSmall
        },
        small: {
          fontSize: vars.fontSizeSmall,
        },
        medium: {
          fontSize: vars.fontSizeMedium,
        },
        large: {
          fontSize: vars.fontSizeLarge,
        }
      },
    }),
  ({background}) =>
    variant({
      prop: "background",
      variants: {
        false: {
          backgroundColor: "transparent",
          padding: "4px 0"
        }
      },
    })
)

const Badge = (props: BadgeProps) => {
  const {text} = props;

  return (
    <BadgeComponent {...props}>
      {text}
    </BadgeComponent>
  )
}

export default Badge;
